/**
 * @author Kelnik
 *
 * Карусель 3-го типа
 */
import {TimelineMax, TweenMax} from 'gsap';
import Slider from 'components/slider';

class SliderThird extends Slider {
    constructor(options) {
        super(options);
        this.container = options.container;
        this.slideImgSelector = '.j-slider-third__slide-img';
        this.slideInfoSelector = '.j-slider-third__slide-info';
        this.slideInfoWrapSelector = '.j-slider-third__slide-info-wrap';
    }

    _initSlick() {
        super._initSlick();
        this._afterInit();
    }

    _afterInit() {
        this.slickTrack = this.$slickElem[0].querySelector('.slick-track');
    }

    _beforeChange(event, slick, currentSlide, nextSlide) {
        super._beforeChange(event, slick, currentSlide, nextSlide);

        this._animateBlockInfo(slick, this.currentSlideEl, this.nextSlideEl);
    }

    /* Анимация слайдера */
    _animateSlideImage(currentSlideEl, nextSlideEl, direction) {
        const clip = this._calcClip(direction, nextSlideEl);

        this._setHeightTrashSlick(nextSlideEl);
        this._toAnimate(clip, currentSlideEl, nextSlideEl);
    }

    /* Анимация доп. блока */
    _animateBlockInfo(slick, currentSlideEl, nextSlideEl) {
        const currentInfo = currentSlideEl.querySelector(this.slideInfoSelector);
        const nextInfo = nextSlideEl.querySelector(this.slideInfoSelector);
        const currentInfoHeight = currentInfo.offsetHeight;
        const nextInfoWrap = nextSlideEl.querySelector(this.slideInfoWrapSelector);
        const currentInfoWrap = currentSlideEl.querySelector(this.slideInfoWrapSelector);
        const htmlNextInfoWrap = nextInfoWrap.innerHTML;
        const tl = new TimelineMax();

        nextInfoWrap.innerHTML = currentInfoWrap.innerHTML;

        tl.to(nextInfoWrap, this.duration / 3, {
            opacity   : 0,
            ease      : this.ease,
            onComplete: () => {
                nextInfoWrap.innerHTML = htmlNextInfoWrap;

                tl.from(nextInfo, this.duration / 3, {
                    height: `${currentInfoHeight}px`,
                    ease  : this.ease
                }).to(nextInfoWrap, this.duration / 3, {
                    opacity   : 1,
                    ease      : this.ease,
                    onComplete: () => {
                        this._clearJsStyles(nextInfoWrap);
                        this._clearJsStyles(nextInfo);
                    }
                });
            }
        });
    }

    _setPosition(event, slick) {
        super._setPosition(event, slick);

        this._setHeightTrashSlick(this.current, true);
    }

    _setHeightTrashSlick(currentSlide, fast = false) {
        const child = currentSlide.firstElementChild;
        const prop = {
            height: child.scrollHeight,
            delay : this.duration / 3
        };

        if (fast) {
            TweenMax.set(this.slickTrack, prop);
        } else {
            TweenMax.to(this.slickTrack, this.duration / 3, prop);
        }
    }
}

export default SliderThird;
